import { faUser, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import SideBar from "../../components/sidebar/Sidebar";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import {
  addAttorneyUsers,
  getAllSharedPropety,
  getAttorneyInvitationByAttorneyId,
  getAttorneyUsersByAttorneyId,
  getBeneficiary,
  getExistUserInAttorneyByUserId,
  getToken,
  getUser,
  getUserModelById,
  initiateProperty,
  pdfGenerate,
  removeAttorneyInvitation,
  updateAttorneyUsers,
} from "../../services/user-service";
import "./TrusteeDashboard.css";
import { Notification } from "../../components/alerting-visitors/notification";
import Deletebutton from "../my-estate/Deletebutton";
import { ConfirmationPopup } from "../my-estate/ConfirmationPopup";

export default function Userdashboard() {
  const [properties, setProperties] = useState([]);

  let user = getUser();
  
  const handleInitiate = (property) => {
    initiateProperty(property)
      .then((res) => {
        toast.success("Property Initiate SuccessFully !!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        // getdata();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGenerate = (property) => {
     pdfGenerate(property)
      .then((response) => {
         const downloadUrl = URL.createObjectURL(response.data);
         const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${getBenificiaryName(property.beneficiaryId)}_${
          property.assetName
        }_${property.id}.pdf`; // Set the desired file name and extension
        link.click();
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {
        // Handle the error
        console.log("error : " + error);
      });
  };


  const base64ToImage = (imageData) => {
    const base64String = imageData;
    const trimmedBase64 = base64String ? base64String.trim() : "";
    if (trimmedBase64) {
      // setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);

      return `data:image/jpeg;base64,${trimmedBase64}`;
    }
    return null;
  };

  const [attorneyUsers, setAttorneyUsers] = useState([]);
  const getAttorneyUserDetail = () => {
    let userId = user.id;
    let token = "Bearer " + getToken();
    getAttorneyUsersByAttorneyId(token, userId)
      .then((res) => {
        setAttorneyUsers(res);
        // base64ToImage(res.data.user.image);
      })
      .catch((err) => console.log(err));
  };

  const [attorneyInvitation, setAttorneyInvitation] = useState([]);
  const getAttorneyInvitationDetail = () => {
    let attorneyEmail = user.email;
    let token = "Bearer " + getToken();
    getAttorneyInvitationByAttorneyId(token, attorneyEmail)
      .then((res) => {
        setAttorneyInvitation(res);
        // base64ToImage(res.data.user.image);
      })
      .catch((err) => console.log(err));
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentUsername, setCurrentUsername] = useState(null);
  const [handleFunctionName, setHandleFunctionName] = useState(null);

  const handleAcceptAndRemoveInvite = (id, username, value) => {
    setShowConfirmation(true);
    setCurrentId(id);
    setCurrentUsername(username);
    setHandleFunctionName(value);
  };

  const handleRemove = (params) => {
    setShowConfirmation(false);
    const { Id, roleText, userName } = params;
    if (roleText === "removeInvitation") {
      let token = "Bearer " + getToken();
      removeAttorneyInvitation(token, userName)
        .then((res) => {
          toast.success(`Invitation Removed!`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          getAttorneyInvitationDetail();
        })
        .catch((error) => {});
    } else {
      let token = "Bearer " + getToken();
      const formData = new FormData();
      getExistUserInAttorneyByUserId(token, Id)
        .then((res) => {
          if (res !== false) {
            const data = {
              id: res.id,
              userId: res.userId,
              attorneyId: res.attorneyId,
              prevUserId: res.prevUserId,
            };
            formData.append("data", JSON.stringify(data));

            updateAttorneyUsers(token, formData)
              .then((res) => {
                toast.success(`Invitation Accepted!`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                getAttorneyUserDetail();
                getAttorneyInvitationDetail();
              })
              .catch((error) => {});
          } else {
            let attorneyId = user.id;

            const data = {
              userId: Id,
              attorneyId: attorneyId,
            };
            formData.append("data", JSON.stringify(data));

            addAttorneyUsers(token, formData)
              .then((res) => {
                toast.success(`Invitation Accepted!`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                getAttorneyUserDetail();
                getAttorneyInvitationDetail();
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {});
    }
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = (userId) => {
     let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => console.log(err));
  };

  const getBenificiaryName = (id) => {
     var foundBenificiary = null;
    if (id.beneficiary === undefined) {
       foundBenificiary = beneficiary.find((b) => b.id === parseInt(id));
    } else {
      foundBenificiary = beneficiary.find(
        (b) => b.id === parseInt(id.beneficiary)
      );
    }
     if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Benificiary not found"; // Or handle the case where beneficiary with the given ID isn't found
    }
  };

  const getPropertyData = () => {
    let userId = user.userid;
    let token = "Bearer " + getToken();
    getAllSharedPropety(token, userId)
      .then((res) => {
         setProperties(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [showUserDetails, setShowUserDetails] = useState(null);
  const [show, setShow] = useState(false);
  const toggleShow = (user) => {
    setShowUserDetails(user);
    setShow(!show);
  };

  useEffect(() => {
    getAttorneyUserDetail();
    getAttorneyInvitationDetail();
  }, []);

  return (
    <TrusteeBase>
      <div style={{ marginTop: "4rem" }}></div>


      <div
        style={{
          backgroundColor: "yellow",
          padding: "3px 0 6px 0",
        }}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Notification />
        </Suspense>
      </div>

      {attorneyInvitation.length > 0 &&
        attorneyInvitation.map((userData, index) => {
          const imageSrc = base64ToImage(userData?.image);
          return (
            <div
              key={index}
              className="add_trustee_list"
              style={{ marginTop: "1.5rem" }}
            >
              <div className="add_trustee_details">
                {imageSrc ? (
                  <img src={imageSrc} alt="Trustee_profile_pic" />
                ) : (
                  <img src="./../img/avtar.jpg" alt="Not Trustee_profile_pic" />
                )}

                <div className="add_trustee_name_email">
                  <div className="add_trustee_name">
                    <li className="add_trustee_name_line">Name: </li>
                    <li>
                      {userData.firstName} {userData.lastName}
                    </li>
                  </div>
                  <div className="add_trustee_email">
                    <li className="add_trustee_email_line">Address: </li>
                    <li>
                      {userData.street && `${userData.street}, `}
                      {userData.city && `${userData.city}, `}
                      {userData.state && `${userData.state}, `}
                      {userData.zip && `${userData.zip} `}
                    </li>
                  </div>
                </div>
              </div>
              <div className="add_trustee_btn">
                <button
                  className="add_trustee_details_btn"
                  onClick={() => {
                    handleAcceptAndRemoveInvite(userData.id, userData.username, 'removeInvitation');
                  }}
                >
                  Cancel
                </button>
                
                <button
                  style={{ border: "none" }}
                  type="button"
                  onClick={() => {
                    handleAcceptAndRemoveInvite(userData.id, userData.email, 'acceptInvite');
                  }}
                  className="add_trustee_Add"
                >
                  Accept Invitation
                </button>
              </div>
            </div>
          );
        })}

      {attorneyUsers.length > 0 &&
        attorneyUsers.map((userData, index) => {
          const imageSrc = base64ToImage(userData?.image);
          return (
            <div
              key={index}
              className="add_trustee_list"
              style={{ marginTop: "1.5rem" }}
            >
              <div className="add_trustee_details">
                {imageSrc ? (
                  <img src={imageSrc} alt="Trustee_profile_pic" />
                ) : (
                  <img src="./../img/avtar.jpg" alt="Not Trustee_profile_pic" />
                )}

                <div className="add_trustee_name_email">
                  <div className="add_trustee_name">
                    <li className="add_trustee_name_line">Name: </li>
                    <li>
                      {userData.firstName} {userData.lastName}
                    </li>
                  </div>
                  <div className="add_trustee_email">
                    <li className="add_trustee_email_line">Address: </li>
                    <li>
                      {userData.street && `${userData.street}, `}
                      {userData.city && `${userData.city}, `}
                      {userData.state && `${userData.state}, `}
                      {userData.zip && `${userData.zip} `}
                    </li>
                  </div>
                </div>
              </div>
              <div className="add_trustee_btn">
                <button
                  className="add_trustee_details_btn"
                  onClick={() => {
                    toggleShow(userData);
                    getBenificiarydata(userData.id);
                  }}
                >
                  Details
                </button>
                <Link
                  className="add_trustee_Add"
                  to={`view-assets/${userData.id}`}
                >
                  View Assets
                </Link>
              </div>
            </div>
          );
        })}

      {show && Object.keys(showUserDetails).length > 0 && (
        <>
          <div className="card__data" style={{ transition: "all 1s ease-out" }}>
            <div className="card__data-container">
              <section className="section1">
                <div>
                  <p className="row1-text">
                    <FontAwesomeIcon
                      icon={faUser}
                      style={{ color: "#025596", fontSize: "18px" }}
                    />
                    <span style={{}}>
                      {showUserDetails.firstName} {showUserDetails.lastName}
                    </span>
                  </p>
                  <div className="row1-button">
                    <div>
                      <span
                        className="card__data-close"
                        onClick={() => {
                          toggleShow();
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="section2">
                <div>
                  <div className="col1">
                    {showUserDetails.firstName && (
                      <p>
                        Name:{" "}
                        <code>
                          {showUserDetails.firstName} {showUserDetails.lastName}
                        </code>
                      </p>
                    )}
                    {showUserDetails.email && (
                      <p>
                        Email:{" "}
                        <code style={{ textTransform: "lowercase" }}>
                          {showUserDetails.email}
                        </code>
                      </p>
                    )}
                    {showUserDetails.dob && (
                      <p>
                        Date of birth: <code>{showUserDetails.dob}</code>
                      </p>
                    )}
                    {showUserDetails.phoneNo && (
                      <p>
                        Phone Number: <code>{showUserDetails.phoneNo}</code>
                      </p>
                    )}
                    {showUserDetails.currentAddress && (
                      <p>
                        Current Address:{" "}
                        <code>{showUserDetails.currentAddress}</code>
                      </p>
                    )}
                  </div>
                  <div className="col2">
                    {showUserDetails.gender && (
                      <p>
                        Gender: <code>{showUserDetails.gender}</code>
                      </p>
                    )}
                    {showUserDetails.meritalStatus && (
                      <p>
                        Marital Status:{" "}
                        <code>{showUserDetails.meritalStatus}</code>
                      </p>
                    )}
                    {showUserDetails.jobStatus && (
                      <p>
                        Job Status: <code>{showUserDetails.jobStatus}</code>
                      </p>
                    )}
                    {showUserDetails.permanentAddress && (
                      <p>
                        Permanent Address:{" "}
                        <code>{showUserDetails.permanentAddress}</code>
                      </p>
                    )}
                    {beneficiary.length > 0 && (
                      <p>
                        Beneficiary:{" "}
                        {beneficiary.map((beneDetails, index) => (
                          <code key={index}>
                            {index > 0 ? ", " : ""}
                            {`${beneDetails.firstName} ${beneDetails.lastName}`}
                          </code>
                        ))}
                      </p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </>
      )}

      {showConfirmation && (
        <ConfirmationPopup
          handleConfirmation={handleRemove}
          handleConfirmationClose={handleConfirmationClose}
          Id={currentId}
          userName={currentUsername}
          roleText={handleFunctionName}
          anyText={
            handleFunctionName === "removeInvitation"
              ? "Are you sure, do you want to remove invite?"
              : "Are you sure, do you want to accept invite?"
          }
        />
      )}
      {/* </SideBar> */}
      {/* <div>
        <Footer />
      </div> */}
    </TrusteeBase>
  );
}
